import React, { useEffect, useState } from 'react';

import * as mapConfig from './map-config';
import FindCare from '../../platformui/Pages/findcare';
import { loadScript } from '../../platformui/Base/Async';

/** Using imported local mapConfig */

const FindCarePage = (props) => {
  const [done, setDone] = useState(false);

  useEffect(() => {
    // Loads markerclusterer as static file with this specific version instead of npm lib due to problems with newer versions in IE.
    loadScript(
      'pwt-markerclusterer-script',
      `/build/${props.Site}/static/markerclustererplus/index.min.js`,
      (e) => {
        if (e) {
          console.error(e.message);
        } else {
          setDone(true);
          console.log('loaded markerclusterer');
        }
      }
    );
  }, []);

  return (
    done && (
      <FindCare
        mapConfig={mapConfig}
        {...props}
        hasAltLayout={true}
        hasCareTypeFilter={false}
      />
    )
  );
};

export default FindCarePage;
